import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import configBase from '../../../../../../configBase';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={0} style={{padding: 11}}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

/* const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
})); */

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    width: '100%',
  },
  tab: {
    backgroundColor: 'transparent',
    border: 'none',
    fontSize: 12,
    textTransform: 'none',
    color: '#606060',
    minWidth: 'auto',
    paddingRight: 0,
  },
  bar: {
    boxShadow: 'none'
  },
  indicator: {
    backgroundColor: 'red'
  }
});

const ScrollableTabsButtonAuto = props => {
  const { contentTabs } = props;

  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar id="barTabs" position="static" color="default" className={classes.bar}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: configBase.corPrincipal
            }
          }}
        >
          <Tab label="Detalhes" className={classes.tab} {...a11yProps(0)} />
          <Tab label="Empresa" className={classes.tab} {...a11yProps(1)} />
          <Tab label="Beneficiários" className={classes.tab} {...a11yProps(2)} />
          <Tab label="Docs Anexados" className={classes.tab} {...a11yProps(3)} />
        </Tabs>
      </AppBar>

      {contentTabs.map((item, index) =>
      <TabPanel key={index} value={value} index={index}>
        <div id="tabContent">{item}</div>
      </TabPanel>
      )}
    </div>
  );
}

ScrollableTabsButtonAuto.propTypes = {
  contentTabs: PropTypes.array
};

export default ScrollableTabsButtonAuto;